import { Dimensions,StyleSheet } from 'react-native';
import { PALETTE } from '../../../constants';
import { MQ_TABLET } from '../../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";

export default MediaQueryStyleSheet.create({
  row: {
    flex: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 10,
    paddingHorizontal: 5,
  },
  listRow: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 15,
  },
  support: {
    flex: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 20,
  },
  logo: {
    height: 30,
    width: 30,
  },
  dateSelectionBar:{
    paddingHorizontal: 5,
    marginTop:5
  },
  textAligning:{
    textAlign: 'center',
    marginTop:10
  },
  seperationBdr: {
    borderWidth: 0.5,
    borderColor: PALETTE.primaryStrokeLine,
    height: 1
  },
  displayPdf: {
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    alignSelf: 'center'
  },
  pdfContainer: {
    flex: 1,
  },
  centerMiddle: {
    position: 'absolute',
    zIndex: 4,
  },
  mrgnLtRt: {
    marginHorizontal: 10
  },
  dateSelectionBar:{
    alignSelf:'center',
  },
  root:{
    marginTop:10
  }
});
